import classNames from 'classnames';
import React from 'react';

import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementKeyboardEvent, ElementMouseEvent} from 'util/Types';

export interface HelpIconProps {
  className?: string;
  onClick?: (e: ElementMouseEvent | ElementKeyboardEvent) => void;
}

const HelpIcon: React.FunctionComponent<HelpIconProps> = ({
  className,
  onClick,
}: HelpIconProps): JSX.Element => (
  <span
    aria-label="Help"
    className={classNames('helpIcon-container', className)}
    {...getActionButtonRoleProps({
      onPress: (e) => {
        onClick?.(e);
      },
    })}
  >
    <BenchlingIcon className="helpIcon" icon="question" />
  </span>
);

export default HelpIcon;
